"use strict";

exports.flag = Symbol("flag");
exports.properties = Symbol("properties");



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/xmlhttprequest-symbols.js
// module id = 6Zry
// module chunks = 1